import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { actionAuth, payout } from "../../http/userAPI"


export const fetchAuth = createAsyncThunk(
    'user/fetchAuth',
    async function ({ action, login, password, email }, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

       

        try {
            const data = await actionAuth(action, login, password, email)
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // <-- сюда пойдет code и message
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)

export const payoutData = createAsyncThunk(
    'user/payoutData',
    async function ({ amount, address }, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

        try {
            const data = await payout(amount, address)
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // <-- сюда пойдет code и message
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)



const userSlice = createSlice({
    name: 'user',
    initialState: {
        isAuth: false,
        user: null,
        isLoading: false,
        error: null
    },
    reducers: {
        setUser(state, action) {
            state.isAuth = true
            state.user = action.payload.user
        },

        removeUser(state) {
            state.isAuth = false
            state.user = null
            localStorage.removeItem('token')
        },
        clearErrors(state) {
            state.error = null
        }
    },
    extraReducers: builder => {
        builder

            .addCase(fetchAuth.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchAuth.rejected, (state, action) => {
                state.isLoading = false;
            
                // Если rejectWithValue с сервером, данные будут в action.payload
                if (action.payload?.message) {
                    state.error = action.payload.message;
                } else {
                    // fallback на стандартное сообщение
                    state.error = action.error?.message || "Возникла ошибка!";
                }
            })
            .addCase(fetchAuth.fulfilled, (state, action) => {
             
                state.isLoading = false
                state.user = action.payload.user
                state.isAuth = true
                localStorage.setItem( 'token', action.payload.token )
            })

            .addCase(payoutData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(payoutData.rejected, (state, action) => {
                state.isLoading = false;
            
                // Если rejectWithValue с сервером, данные будут в action.payload
                if (action.payload?.message) {
                    state.error = action.payload.message;
                } else {
                    // fallback на стандартное сообщение
                    state.error = action.error?.message || "Возникла ошибка!";
                }
            })
            .addCase(payoutData.fulfilled, (state, action) => {
                
                state.isLoading = false
                state.user = action.payload.user
            })
    }
});

export const {
    setUser,
    removeUser,
    clearErrors
} = userSlice.actions;

export default userSlice.reducer